import { createAsyncThunk } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

//Include Both Helper File with needed methods
import {
	getPeriodicityList as getPeriodicityListApi,
	getPeriodicity as getPeriodicityApi,
	getPeriodicityByCode as getPeriodicityByCodeApi,
	addNewPeriodicity as addNewPeriodicityApi,
	updatePeriodicity as updatePeriodicityApi,
	deletePeriodicity as deletePeriodicityApi,
} from '../../helpers/normative/backend_helper';

export const getPeriodicityList = createAsyncThunk('periodicities/getPeriodicityList', async () => {
	try {
		const response = getPeriodicityListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPeriodicity = createAsyncThunk('periodicities/getPeriodicity', async periodicity_id => {
	try {
		const response = getPeriodicityApi(periodicity_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getPeriodicityByCode = createAsyncThunk('periodicities/getPeriodicityByCode', async periodicity_id => {
	try {
		const response = getPeriodicityByCodeApi(periodicity_id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewPeriodicity = createAsyncThunk('periodicities/addNewPeriodicity', async periodicity => {
	try {
		const response = addNewPeriodicityApi(periodicity);
		toast.success('Periocidad agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar periodicity.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updatePeriodicity = createAsyncThunk('periodicities/updatePeriodicity', async (periodicity) => {
		try {
			const response = updatePeriodicityApi(periodicity);
			toast.success('Periocidad actualizado exitosamente', { autoClose: 3000 });
			return response;
		} catch (error) {
			toast.error('Error al actualizar periodicity.', { autoClose: 3000 });
			throw new Error(error);
		}
	}
);

export const deletePeriodicity = createAsyncThunk('periodicities/deletePeriodicity', async periodicity => {
	try {
		const response = await deletePeriodicityApi(periodicity);
		toast.success('Periocidad eliminado exitosamente.', { autoClose: 3000 });
		return { periodicity, ...response };
	} catch (error) {
		toast.error('Error al eliminar periodicity.', { autoClose: 3000 });
		throw new Error(error);
	}
});
